// 秒数格式化为时间码 "HH:MM:SS"（时 / 分 / 秒均两位补零）；NaN / 负数兜底 "00:00:00"。
// 与 formatDurationMs 区别：入参单位为秒（可含小数，向下取整），并对非法值做兜底——
// 适用于播放进度 / 视频锚点等可能出现 NaN（元数据未就绪）的场景。
export const formatTimecode = (seconds: number): string => {
  if (!Number.isFinite(seconds) || seconds < 0) {
    return '00:00:00'
  }
  const total = Math.floor(seconds)
  const pad = (n: number): string => String(n).padStart(2, '0')
  return `${pad(Math.floor(total / 3600))}:${pad(Math.floor((total % 3600) / 60))}:${pad(total % 60)}`
}
